module.exports = __webpack_public_path__ + "static/media/Articles_Hero_Tablet.08219fa4.png";